<!-- MasterLayout.vue -->
<script setup lang="ts">
import { ref, onMounted, onUnmounted, inject, computed } from "vue";
import { EventBus } from "@/code/event-bus";
import { useToastLogStore } from "@/store/toast-log";
import { toast } from "vue3-toastify";

const vuetify = inject("vuetify");

let stored = localStorage.getItem("DarkMode");
if (stored === null) {
  localStorage.setItem("DarkMode", "true");
  stored = "true";
}
const isDarkMode = ref(stored === "true");

const currentTheme = computed(() => {
  return isDarkMode.value ? "OniTheme" : "PurpleTheme";
});

const updateTheme = (event?: { message: boolean }) => {
  if (event && typeof event.message === "boolean") {
    isDarkMode.value = event.message;
  } else {
    isDarkMode.value = localStorage.getItem("DarkMode") === "true";
  }
};

const toastLogStore = useToastLogStore();
const handler = (event: { type: any; message: any }) => {
  const { type, message } = event;
  toast(message, { type });
  toastLogStore.addToast({ type, message });
};

onMounted(() => {
  EventBus.on("toast", handler);
  EventBus.on("themeChange", updateTheme);
  updateTheme(); 
  if (
    vuetify &&
    vuetify.theme &&
    vuetify.theme.global &&
    vuetify.theme.global.name
  ) {
    vuetify.theme.global.name.value = isDarkMode.value ? "OniTheme" : "PurpleTheme";
  }
});

onUnmounted(() => {
  EventBus.off("toast", handler);
});
</script>

<template>
  <v-theme-provider :theme="currentTheme">
    <slot></slot>
  </v-theme-provider>
</template>

<style>
.thumbnail {
  width: 70px;
  min-width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
    :root {
      --bg: #0f1117;
      --surface: #161b22;
      --surface-elevated: #1c2128;
      --border: #30363d;
      --text: #e6edf3;
      --text-muted: #8b949e;
      --primary: #6e40c9;
      --primary-hover: #7c4ddf;
      --success: #3fb950;
      --warning: #d29922;
      --warning-bg: rgba(210, 153, 34, 0.12);
      --danger: #f85149;
      --radius: 12px;
      --font: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
    
      --toastify-color-info: #3d39a7;
      --toastify-color-success: #15d384;
      --toastify-color-warning: #faae00d1;
      --toastify-color-error: #f71e9d;
      --toastify-color-dark: #323232;
}
.details-container {
  display: flex;
  flex-direction: column;
  flex: 0 0 calc(33.33% - 15px);
  gap: 16px;
  padding: 16px 0;
}
.detail-section {
  border-radius: 4px;
  padding: 8px;
  border: #dddddd22 solid 3px;
}

.detail-header {
  font-weight: bold;
  margin-bottom: 8px;
}

.detail-items {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  padding: 4px;
  border-color: #dddddd22;
  padding: 8px;
  border-radius: 4px;
}

.detail-item > div {
  flex: 1;
}
.gap-15 {
  gap: 15px;
}
.bucket-reward {
  border-radius: 8px;
  padding: 16px;
  background: #eeeeee30;
}
.v-navigation-drawer__content {
  background: #b26eff0d;
}
/* CSS to hide v-input__details when it contains only empty div or is effectively empty */
.v-input__details:empty,
.v-input__details:has(> :empty) {
  display: none;
}

.stricken {
  text-decoration: line-through;
}
.formula-container {
  border-radius: 8px;
  padding: 16px;
  background: #eeeeee30;
  margin-bottom: 16px;
}

.v-input__details {
  display: none !important;
}
.stricken {
  text-decoration: line-through;
}
.migration-container {
  border-radius: 8px;
  padding: 16px;
  background: #eeeeee30;
  margin-bottom: 16px;
}
</style>
